// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__-HJJU","background":"NotFound_background__G7SWG","glow":"NotFound_glow__Ed4Aq","glowing":"NotFound_glowing__KOOUG"};